/* eslint-disable no-control-regex */

// Bringing in a feature from React itself that'll be enforced in future versions
// https://github.com/facebook/react/blob/a724a3b578dce77d427bef313102a4d0e978d9b4/packages/react-dom/src/shared/sanitizeURL.js#L22

// A javascript: URL can contain leading C0 control or \u0020 SPACE,
// and any newline or tab are filtered out as if they're not part of the URL.
// https://url.spec.whatwg.org/#url-parsing
// Tab or newline are defined as \r\n\t:
// https://infra.spec.whatwg.org/#ascii-tab-or-newline
// A C0 control is a code point in the range \u0000 NULL to \u001F
// INFORMATION SEPARATOR ONE, inclusive:
// https://infra.spec.whatwg.org/#c0-control-or-space
const isJavaScriptProtocol =
  /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;

const isDataProtocol = /^[\u0000-\u001F ]*d[\r\n\t]*a[\r\n\t]*t[\r\n\t]*a[\r\n\t]*:/i;

const safeOrigin = 'https://www.exploretock.com';

// prevent xss attacks
export const isValidHref = (href = '', options?: { allowDataProtocolUrl?: boolean }): boolean => {
  // Encoding first to prevent the decodeURIComponent function from throwing an error due to illegal input characters
  const encodedHref = encodeURIComponent(href);
  const decodedHref = decodeURIComponent(encodedHref);
  const shouldBlockDataUrl = !options?.allowDataProtocolUrl && isDataProtocol.test(decodedHref);
  return !(isJavaScriptProtocol.test(decodedHref) || shouldBlockDataUrl);
};

// Multiple levels of url encoding can result in turning a path like "/%2509/example.com" into "/\t/example.com" which
// the browser ultimately interprets as a url with example.com as the origin (which is not what we want). This method
// decodes until there are no changes in the content.
const decodeFully = (url: string) => {
  let previous;
  let current = url;
  do {
    previous = current;
    current = decodeURIComponent(previous);
  } while (previous !== current);
  return current;
};

// Only allow relative urls or exploretock.com paths. We only use paths, this approach allows us to take advantage of
// the built-in URL class for parsing encoded url values.
export const isSafeContinuePath = (path = ''): boolean => {
  try {
    // A URL starting with "/" but without a protocol is considered relative. By passing a base url to the constructor,
    // it will use that base url if no origin is provided.
    const parsedUrl = new URL(decodeFully(path), safeOrigin);

    // If the origin matches our safe origin, we confirm that the original path was either an exploretock.com url or a
    // relative path. Either one is safe.
    return parsedUrl.origin === safeOrigin;
  } catch {
    return false; // Invalid URLs are rejected
  }
};
